/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



/* ============================================================
   KALAMO – Botón "Cargar más" en páginas de colección
   Reemplaza la paginación numérica por un botón que añade
   los productos de la página siguiente a la parrilla actual.
   Conservador: si algo falla, deja la paginación original.
   ============================================================ */
(function () {
  function initLoadMore() {
    var productList = document.querySelector('.product-list--collection');
    var pagination = document.querySelector('.pagination');
    if (!productList || !pagination) return;

    // Buscar el enlace "siguiente"
    var nextLink = pagination.querySelector('.pagination__next');
    if (!nextLink) { pagination.style.display = 'none'; return; }

    var nextUrl = nextLink.getAttribute('href');

    // Ocultar la paginación numérica y crear el botón
    pagination.style.display = 'none';

    var wrap = document.createElement('div');
    wrap.className = 'kalamo-load-more-wrap';
    wrap.style.cssText = 'text-align:center;margin:30px 0;';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button button--primary kalamo-load-more';
    btn.textContent = 'Cargar más';
    wrap.appendChild(btn);
    pagination.parentNode.insertBefore(wrap, pagination);

    var loading = false;

    btn.addEventListener('click', function () {
      if (loading || !nextUrl) return;
      loading = true;
      btn.textContent = 'Cargando…';
      btn.disabled = true;

      fetch(nextUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newItems = doc.querySelectorAll('.product-list--collection .product-item');
          newItems.forEach(function (item) {
            productList.appendChild(item);
          });

          // Actualizar el enlace "siguiente" para la próxima tanda
          var newNext = doc.querySelector('.pagination__next');
          if (newNext) {
            nextUrl = newNext.getAttribute('href');
            btn.textContent = 'Cargar más';
            btn.disabled = false;
            loading = false;
          } else {
            // No hay más páginas: quitar el botón
            wrap.remove();
          }

          // Avisar al theme por si necesita re-inicializar (lazy images, etc.)
          document.documentElement.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
        })
        .catch(function () {
          // Si falla, restaurar la paginación original como respaldo
          btn.textContent = 'Cargar más';
          btn.disabled = false;
          loading = false;
          pagination.style.display = '';
          wrap.remove();
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLoadMore);
  } else {
    initLoadMore();
  }
})();



/* ============================================================
   KALAMO – Cerrar la barra fina de anuncios "Suscríbete y ahorra"
   Al pulsar la X se oculta y se recuerda durante 24 HORAS
   (localStorage + marca de tiempo). Pasadas 24h reaparece sola.
   ============================================================ */
(function () {
  var HIDE_MS = 24 * 60 * 60 * 1000; // 24 horas
  var KEY = 'kalamoAnnouncementClosedAt';

  function initAnnouncementClose() {
    var bar = document.querySelector('.shopify-section--announcement-bar');
    var btn = document.querySelector('.kalamo-announcement-close');
    if (!bar || !btn) return;

    // Limpiar el flag antiguo de sesión (migración de la versión anterior)
    try { sessionStorage.removeItem('kalamoAnnouncementClosed'); } catch (e) {}

    // Si se cerró hace MENOS de 24h, ocultar; si ya pasaron 24h, mostrar y limpiar
    try {
      var closedAt = parseInt(localStorage.getItem(KEY), 10);
      if (closedAt && (Date.now() - closedAt) < HIDE_MS) {
        bar.style.display = 'none';
        return;
      } else if (closedAt) {
        localStorage.removeItem(KEY);
      }
    } catch (e) {}

    btn.addEventListener('click', function () {
      bar.style.display = 'none';
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncementClose);
  } else {
    initAnnouncementClose();
  }
})();



/* ============================================================
   KALAMO – Valoraciones (estrellas) justo debajo del título
   El bloque "Star rating widget" (bloque de app) se coloca, por
   diseño del editor, ENCIMA del título. Aquí lo movemos para que
   quede dentro del meta, justo debajo del título del producto.
   Robusto: mueve el bloque que esté inmediatamente antes de
   "Product meta" a continuación del título.
   ============================================================ */
(function () {
  function placeRatingUnderTitle() {
    var metaItem = document.querySelector('.product-info__block-item--product-meta');
    if (!metaItem) return;
    var title = metaItem.querySelector('.product-meta__title');
    var ratingItem = metaItem.previousElementSibling;
    if (!title || !ratingItem) return;
    if (!ratingItem.classList || !ratingItem.classList.contains('product-info__block-item')) return;
    if (ratingItem.dataset.kalamoMoved === '1') return;

    title.insertAdjacentElement('afterend', ratingItem);
    ratingItem.dataset.kalamoMoved = '1';
    ratingItem.classList.add('kalamo-rating-under-title');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeRatingUnderTitle);
  } else {
    placeRatingUnderTitle();
  }
})();



/* ============================================================
   KALAMO – "Añadir a lista de deseos" a la derecha del botón comprar
   Mueve ÚNICAMENTE el bloque del corazón (Growave faveButton) a una
   fila flex (.kalamo-buy-row) junto al botón de compra, alineados.
   Se identifica por data-block-id*="fave_button", de modo que NO toca
   el bloque de valoraciones (review_avg_profile), que también es de
   Growave: ese fue el motivo del fallo del intento anterior.
   Idempotente; se re-aplica si el theme re-renderiza al cambiar de
   variante o si Growave carga de forma asíncrona.
   ============================================================ */
(function () {
  var FAVE_SEL = '.product-info__block-item[data-block-id*="fave_button"]';
  var BUY_SEL  = '.product-info__block-item[data-block-id="buy_buttons"]';

  function alignWishlist() {
    var buyBlock = document.querySelector(BUY_SEL);
    if (!buyBlock) return;
    var container = buyBlock.querySelector('.product-form__payment-container');
    if (!container) return;
    var fave = document.querySelector(FAVE_SEL);
    if (!fave) return;
    var cta = container.querySelector('buy-button') || container.querySelector('.product-form__add-button');
    if (!cta) return;

    var row = container.querySelector('.kalamo-buy-row');
    if (!row) {
      row = document.createElement('div');
      row.className = 'kalamo-buy-row';
      cta.parentNode.insertBefore(row, cta);
      row.appendChild(cta);
    }
    if (fave.parentNode !== row) {
      fave.classList.add('kalamo-wishlist-item');
      row.appendChild(fave);
    }
  }

  function run() {
    alignWishlist();
    setTimeout(alignWishlist, 500);
    setTimeout(alignWishlist, 1500);

    var scope = document.querySelector('[data-section-type="product"]') || document.body;
    if (scope && window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          alignWishlist();
        });
      }).observe(scope, { childList: true, subtree: true });
    }
    document.addEventListener('variant:changed', function () { setTimeout(alignWishlist, 50); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();



/* ============================================================
   KALAMO – "Todas las colecciones": buscador por letras (A-Z)
   + botón "Cargar más" (en vez de paginación numérica).
   Ambos funcionan juntos: el "Cargar más" muestra por tandas
   dentro de la letra seleccionada.
   ============================================================ */
(function () {
  var BATCH = 24;

  function firstLetter(text) {
    var t = (text || '').trim().normalize('NFD').replace(/[̀-ͯ]/g, '');
    var ch = t.charAt(0).toUpperCase();
    return /[A-Z]/.test(ch) ? ch : '#';
  }

  function initCollectionsTools() {
    var section = document.querySelector('[data-section-type="list-collections"]');
    if (!section) return;
    var grid = section.querySelector('.collection-list__section .grid');
    if (!grid || grid.dataset.kalamoTools === '1') return;
    var cells = Array.prototype.slice.call(grid.querySelectorAll('.grid__cell'));
    if (cells.length === 0) return;
    grid.dataset.kalamoTools = '1';

    cells.forEach(function (cell) {
      var titleEl = cell.querySelector('.collection-block-item__title');
      cell.dataset.letter = firstLetter(titleEl ? titleEl.textContent : '');
    });

    var letters = [];
    cells.forEach(function (c) { if (letters.indexOf(c.dataset.letter) < 0) letters.push(c.dataset.letter); });
    letters.sort();

    // Barra A-Z
    var bar = document.createElement('div');
    bar.className = 'kalamo-az-bar';
    var allBtn = document.createElement('button');
    allBtn.type = 'button';
    allBtn.className = 'kalamo-az-letter is-active';
    allBtn.textContent = 'Todas';
    allBtn.dataset.letter = '';
    bar.appendChild(allBtn);
    letters.forEach(function (L) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kalamo-az-letter';
      b.textContent = L;
      b.dataset.letter = L;
      bar.appendChild(b);
    });
    grid.parentNode.insertBefore(bar, grid);

    // Botón "Cargar más"
    var moreWrap = document.createElement('div');
    moreWrap.className = 'kalamo-loadmore-wrap';
    var moreBtn = document.createElement('button');
    moreBtn.type = 'button';
    moreBtn.className = 'button button--primary kalamo-loadmore';
    moreBtn.textContent = 'Cargar más';
    moreWrap.appendChild(moreBtn);
    grid.parentNode.insertBefore(moreWrap, grid.nextSibling);

    // Ocultar la paginación numérica del theme si quedara alguna
    var pag = section.querySelector('.pagination');
    if (pag) pag.style.display = 'none';

    var activeLetter = '';
    var shown = BATCH;

    function matches() {
      return cells.filter(function (c) { return !activeLetter || c.dataset.letter === activeLetter; });
    }
    function render() {
      var m = matches();
      cells.forEach(function (c) { c.style.display = 'none'; });
      m.slice(0, shown).forEach(function (c) { c.style.display = ''; });
      moreWrap.style.display = (m.length > shown) ? '' : 'none';
    }

    moreBtn.addEventListener('click', function () { shown += BATCH; render(); });

    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('.kalamo-az-letter');
      if (!btn) return;
      activeLetter = btn.dataset.letter || '';
      shown = BATCH;
      bar.querySelectorAll('.kalamo-az-letter').forEach(function (x) { x.classList.remove('is-active'); });
      btn.classList.add('is-active');
      render();
    });

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionsTools);
  } else {
    initCollectionsTools();
  }
})();



/* ============================================================
   KALAMO – "Leer más" en la descripción del Featured product (home)
   Recorta la descripción y añade un botón para expandir/contraer.
   Limitado a la sección featured-product (no afecta a la ficha real).
   ============================================================ */
(function () {
  function initReadMore() {
    var section = document.querySelector('.featured-product');
    if (!section) return;

    // Buscar el bloque de descripción dentro de esta sección
    var desc = section.querySelector('.product-meta__description, .product-description, .rte');
    if (!desc) return;
    if (desc.classList.contains('kalamo-desc-clamp')) return; // ya procesado

    desc.classList.add('kalamo-desc-clamp');

    // Solo añadir botón si el texto realmente desborda
    // (esperamos un tick para que el clamp se aplique)
    setTimeout(function () {
      if (desc.scrollHeight <= desc.clientHeight + 4) return; // no desborda, sin botón

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kalamo-readmore-btn';
      btn.textContent = 'Leer más';
      desc.parentNode.insertBefore(btn, desc.nextSibling);

      btn.addEventListener('click', function () {
        var expanded = desc.classList.toggle('is-expanded');
        btn.textContent = expanded ? 'Leer menos' : 'Leer más';
      });
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReadMore);
  } else {
    initReadMore();
  }
})();



/* ============================================================
   KALAMO – Buscar por ISBN (SKU) en el buscador instantáneo
   El desplegable del buscador (predictive) de Shopify NO mira el
   SKU por defecto (solo título, tipo, variante y proveedor). Aquí
   interceptamos su petición y añadimos el SKU y el código de barras
   a los campos buscados, de modo que al teclear un ISBN aparezcan
   los libros también en el desplegable.
   A prueba de fallos: si algo no encaja, deja la petición intacta
   (nunca rompe el buscador ni el resto de peticiones). La página de
   resultados ya busca por SKU por su cuenta; esto solo cubre el
   desplegable instantáneo.
   Se ejecuta de inmediato (no en DOMContentLoaded) para parchear
   window.fetch antes de que el usuario empiece a teclear.
   ============================================================ */
(function () {
  if (window.__kalamoSearchSkuPatched) return;
  window.__kalamoSearchSkuPatched = true;

  // Solo título + ISBN/EAN (guardado en el SKU y, por si acaso, en el código de barras).
  var FIELDS = 'title,variants.sku,variants.barcode';

  function setField(url, paramName) {
    var re = new RegExp(paramName.replace(/[[\]]/g, '\\$&') + '=[^&]*');
    if (re.test(url)) return url.replace(re, paramName + '=' + FIELDS);
    return url + (url.indexOf('?') === -1 ? '?' : '&') + paramName + '=' + FIELDS;
  }

  function patchUrl(url) {
    if (typeof url !== 'string') return url;
    // Endpoint de sugerencias (API predictive): usa resources[options][fields]
    if (url.indexOf('/search/suggest') !== -1) return setField(url, 'resources[options][fields]');
    // Desplegable que renderiza la búsqueda normal por sección: usa options[fields]
    if (url.indexOf('section_id=predictive-search') !== -1) return setField(url, 'options[fields]');
    return url;
  }

  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        if (typeof input === 'string') {
          input = patchUrl(input);
        } else if (input && typeof input.url === 'string') {
          var newUrl = patchUrl(input.url);
          if (newUrl !== input.url) input = new Request(newUrl, input);
        }
      } catch (e) { /* fail-open: nunca romper fetch */ }
      return originalFetch.call(this, input, init);
    };
  }
})();
